
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 6C3.355 6 2 7.355 2 9v14c0 1.645 1.355 3 3 3h22c1.645 0 3-1.355 3-3V9c0-1.645-1.355-3-3-3zm0 2h22c.566 0 1 .434 1 1v14c0 .566-.434 1-1 1H5c-.566 0-1-.434-1-1V9c0-.566.434-1 1-1zm14.406 4.375c-1.926 0-2.937.95-2.937 2.156 0 2.18 2.562 1.88 2.562 3 0 .192-.16.625-1.218.625-1.06 0-1.75-.375-1.75-.375l-.313 1.438s.656.406 1.969.406c1.312 0 3.156-1.008 3.156-2.469 0-1.758-2.563-1.875-2.563-2.656 0-.398.34-.719 1.25-.719.594 0 1.25.469 1.25.469l.313-1.531s-.871-.344-1.719-.344zm-8.218.125L9.5 17.438s-.086-.426-.125-.688c-.953-2.14-2.5-2.938-2.5-2.938l1.469 5.594h2l2.812-6.906zm2.687 0l-1.094 6.906h1.844l1.094-6.906zm9.938 0l-3 6.906h1.812l.375-.968h2.313l.187.968h1.656L25.75 12.5zm-18.97.031s3.598 1.102 4.438 3.813l-.625-3.125s-.273-.688-1-.688zM24.5 14.5l.531 2.594h-1.5z"}})])
          )
        }
      }
    